import { createSlice } from "@reduxjs/toolkit";

const twoColumnChartSliceVolume = createSlice({
    name: "twoColumnChartVolume",
    initialState: {
      currentVolumeSalesType: null, // default sales type
    },
    reducers: {
      updateVolumeSalesType: (state, action) => {
        state.currentVolumeSalesType = action.payload;
      },
    },
  });

  export const { updateVolumeSalesType } = twoColumnChartSliceVolume.actions;
  export default twoColumnChartSliceVolume.reducer;
